import { GetMacroplanogramInput, useGetMacroplanogramQuery } from '@graphql/generated/graphql';
import { AgileMacroplanogram, AgileMacroplanogramResult } from 'src/components/agile/types/AgileMacroplanogramTypes';
import { parseMacroData } from '@components/agile/utils/FixtureDataUtils';
import { MacroData } from '@components/agile/types/zoneMapType';

const useGetMacroplanogramResults = (input: GetMacroplanogramInput) => {
  const { ...restInput } = input;

  const { data, isSuccess } = useGetMacroplanogramQuery(
    {
      input: {
        ...restInput,
      },
    },
    {
      // disable refetchOnWindowFocus so that data is not refreshed
      // when user leave the page and come back
      refetchOnWindowFocus: false,
    },
  );
  const macroplanogramList: AgileMacroplanogram[] | undefined | null = data?.getMacroplanogram.macroplanogram;

  let zoneNameList: MacroData[] = [];
  if (macroplanogramList) {
    zoneNameList = parseMacroData(macroplanogramList);
  }
  return {
    macroplanogramList,
    zoneNameList,
    isSuccess,
  } as AgileMacroplanogramResult;
};

export default useGetMacroplanogramResults;
